// @flow
import { default as linkLoader } from "./linkLoader";
import { default as scriptLoader } from "./scriptLoader";

export default [linkLoader, scriptLoader];
